<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to=''>会员中心</router-link></li>
                <li class="currentNode"><a>会员信息</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>会员信息</h3>
                    <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="form" size="small">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="form.name" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="手机" prop="phone">
                            <el-input v-model="form.phone" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="form.email" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="公司名称" prop="company">
                            <el-input v-model="form.company"></el-input>
                        </el-form-item>
                        <el-form-item label="办公地点" prop="address">
                            <el-input v-model="form.address"></el-input>
                        </el-form-item>
                        <el-form-item label="办公电话" prop="tel">
                            <el-input v-model="form.tel"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onSubmit" class="submitBtn">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    getAccountModel,
    editAccount
} from '@services/tokenService.js';
import rulesPattern from '@/assets/utils/rulesPattern.js';
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    name:'',
    components: { PersonCenterMenu },
    data() {
        return {
            editId: '',
            form:{
                name: '',
                phone: '',
                email: '',
                company: '',
                address: '',
                tel: '',
            },
            rules: {
                name: [
                    { required: false, message: '请输入姓名', trigger: 'blur' },
                    // { min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: false, message: '请输入手机号', trigger: 'blur' },
                    // { pattern: rulesPattern.phone, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                email: [
                    { required: false, message: '请输入邮箱', trigger: 'blur' },
                    // { pattern: rulesPattern.email, message: '请输入正确的邮箱', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                address: [
                    { required: true, message: '请输入办公地点', trigger: 'blur' },
                ],
                tel: [
                    { required: true, message: '请输入办公电话', trigger: 'blur' },
                    { pattern: rulesPattern.phoneAndTel, message: '请输入正确的手机号或者座机号格式为：0000-0000000', trigger: 'blur' }
                ],
            }
        }
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
    },
    created() {
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
        } else {
            this.getAccountModel();
        }
    },
    methods: {
        getAccountModel() {
            let param = {
                accountid: this.accountId,
            };
            getAccountModel(param).then(res => {
                if (res.Code == 1) {
                    AccountId: this.accountId,
                    this.form.name = res.Data.LoginName;
                    this.form.phone = res.Data.UserName;
                    this.form.company = res.Data.AccCompanyName;
                    this.form.tel = res.Data.LinkPhone;
                    this.form.email = res.Data.AccCityName;
                    this.form.address = res.Data.AccProvinceName;
                } else {
                    this.$message.error("获取用户信息失败");
                }
            })
        },
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let param = {
                        AccountId: this.accountId,
                        LoginName: this.form.name,
                        UserName: this.form.phone,
                        AccCompanyName: this.form.company,
                        LinkPhone: this.form.tel,
                        AccCityName: this.form.email,
                        AccProvinceName: this.form.address
                   };
                    editAccount(param).then(res => {
                        if (res.Code == 1) {
                            this.$message.success("保存成功！");
                        } else {
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    return false;
                }
            });
        }
    },
}
</script>

<style scoped>
.page-content {
    padding: 30px;
    min-height: 750px;
}
.page-content h3{
    text-align:center;
    margin-bottom: 20px;
}
.form{
    width: 450px;
    margin: 0 auto;
}
.vertical-nav li a.active {
    border-left: none;
}
.el-button:focus, .el-button:hover {
    color: #fff;
    border-color: #005091;
    background-color: #005091;
}
</style>